import { type InferOutput, minLength, object, pipe, string } from 'valibot'

export const csvImportFormValueSchema = object({
  fileKey: pipe(string(), minLength(1)),
  fileName: pipe(string(), minLength(1))
})

/**
 * CSVインポートのフォーム値
 */
export type CsvImportFormValue = InferOutput<typeof csvImportFormValueSchema>
